export default __webpack_public_path__ + "static/media/bf745de25a6ebece.7f4390dfa6f65c91ef670c3975f65f88.svg";